import Notification from '../state/notification';

export const createNotificationRequestPayload = (notification) => (
    new Notification({
        shortText: notification.shortText,
        language: notification.language,
        title: notification.title,
        url: notification.url,
    })
);
